// viewer 가 iframe 으로 분리된 컨텍스트인지 판정.
//
// iframe 모드: viewer 가 host 의 iframe 으로 분리되어 별도 window context 에서 실행.
//   native (iOS/Android) 가 viewer 의 contentWindow 에 글로벌 함수 (MailView /
//   setDarkMode / uiWebview_* 등) 를 직접 호출. 글로벌 등록 + host document 에 직접
//   listener 등록이 정상 동작.
//
// inner 모드: viewer 가 host SPA 와 같은 window 에서 실행 (Phase 0~5 inner-viewer).
//   글로벌 등록은 host namespace 오염을 유발하므로 생략 — named export 로 import.
//   host document 에 listener 등록은 viewer 외 host UI 클릭/blur 까지 catch 하는
//   회귀 (R13/R22/R23) 를 만들므로 가드 필요.
//
// 본 helper 는 mailview.ts / singleUse.ts / EmailContainer 등 viewer 영역의 단일
// source of truth. 호출은 모듈 평가 시 또는 lifecycle 진입 시 1 회로 충분 (window.parent
// 는 런타임 중 변하지 않음).

export function isIframeMode(): boolean {
  return window.parent !== window
}
